module.exports = __webpack_public_path__ + "static/media/AI-扩展转接.b591200d.jpg";